import React, { Component, createRef, ReactNode } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import {
  ModalBackdrop,
  ModalWrapper,
  Title,
  TitleText,
  CloseButton,
  ModalBody,
  Paragraph,
  ButtonsWrapper,
  Button,
} from "./styles/create-job-confirmation-modal-styles";

class CreateJobConfirmationModal extends Component<unknown, unknown> {
  private backdrop = createRef<HTMLDivElement>();

  closeModal = (): void => {
    const backdrop = this.backdrop.current;

    if (backdrop) {
      backdrop.classList.remove("active");
    }
  };

  render(): ReactNode {
    return (
      <ModalBackdrop
        id="job-confirmation-modal-backdrop"
        ref={this.backdrop}
        data-test-id="job-confirmation-modal-backdrop"
      >
        <ModalWrapper>
          <Title data-test-id="job-confirmation-modal-title">
            <TitleText>Create a Job</TitleText>
            <CloseButton onClick={this.closeModal}>
              <FontAwesomeIcon icon={faTimes} />
            </CloseButton>
          </Title>
          <ModalBody>
            <Paragraph>
              This job is about to go live.
              <br />
              Are you sure?
            </Paragraph>
            <ButtonsWrapper>
              <Button
                type="submit"
                id="submit_job"
                name="job[published_status]"
                value="live"
              >
                yes
              </Button>
              <Button type="button" onClick={this.closeModal}>
                no
              </Button>
            </ButtonsWrapper>
          </ModalBody>
        </ModalWrapper>
      </ModalBackdrop>
    );
  }
}

export default CreateJobConfirmationModal;
